<style lang="sass" scoped>
.pay-sus
    text-align: center
    padding: 20px
    .ok-top
        padding-bottom: 20px
        border-bottom: 1px solid #e9e9e9
        font-size: 18px
        font-weight: 600
        img
            width: 185px
            margin: 10px auto
    .left-right
        margin-top: 20px
    .qrs
        .qr
            display: inline-block
            margin: 30px
            font-size: 16px
            line-height: 30px
        img
            
            width: 160px
            height: 160px
            border: 1px solid #e9e9e9

    .btn
        display: inline-block
        width: 160px
        height: 40px
        line-height: 40px
        font-size: 16px
        color: #FF3973
        border: 1px solid #FF3973
        border-radius: 4px
        margin: 40px
        cursor: pointer
        &.cur
            border: none
            color: #fff
            background: linear-gradient(315deg,rgba(255,132,109,1) 0%,rgba(255,57,115,1) 100%)

</style>

<template lang="pug">
main-right(:title="pageTitle")
    .pay-sus
        .ok-top
            img(src="../../assets/pay-ok.png")
            div 恭喜您，购买完成！您已成功支付{{orderData.amount | fix2}}元
        div
            .left-right 订单号：
                span {{orderData.orderCode}}
            .left-right.no-br 订单金额：
                span {{orderData.amount | fix2}}元
        .qrs
            .qr(v-for="(item, i) in qrs" :key="i")
                img(:src="item.url")
                .name {{item.name}}
        .btns
            .btn(@click="seeDtl" v-if="showSeeDtl") 查看订单详情
            .btn.cur(@click="upVideo") {{opStr}}广告素材

        UploadVideo(v-model="orderDataCopy" @upDone="opStr='更换'")
</template>

<script>
import UploadVideo from '@/components/UploadVideo'
import { getOrderDetail } from "@/utils/api"
import qrAndroid from '../../assets/qrAndroid.png'
import qrIos from '../../assets/qrIos.png'

export default {
    name: 'order-pay-ok',
    components: { UploadVideo },
    filters: {
        fix2 (v) {
            return v ? v.toFixed(2) : 0
        }
    },
    data () {
        return {
            qrs: [
                {url: qrAndroid, name: '下载Android APP'},
                {url: qrIos, name: '下载IOS APP'}
                // ,{url: qr, name: '关注公众号，领取优惠券'}
            ],
            orderData: {
                amount: 0,
                orderCode: ''
            },
            advContentDto: null,
            orderDataStr: '',
            orderDataCopy: {
                showUpload: false
            },
            opStr: '上传',
            orderFrom: this.$route.query.from || 'map',
            pageTitle: this.orderFrom === 'map' ? '地图投放' : '智能快速发布',
            showSeeDtl: false
        }
    },
    async created () {
        if (!this.$route.query.isPkg) this.showSeeDtl = true
        this.getDetail()
    },
    methods: {
        async getDetail () {
            const oid = this.$route.query.orderId
            if (!oid) return {}
            const res = await getOrderDetail({ guid: oid })
            if (res && res.code === this.successCode) {
                this.orderData = res.data || {}
                if (this.orderData.contentName) this.opStr = '更换'
                this.orderDataStr = JSON.stringify(this.orderData)
                return JSON.parse(JSON.stringify(res.data))
            }
            return {}
        },
        seeDtl () {
            const oid = this.$route.query.orderId
            if (!oid) return this.$message.warning('无效订单ID')
            this.goUrl('/mapOrderDetail', { id: oid })
            tzx_czcPush('order_payok', 'seeDetail')
        },
        async getOldResource (id) {
            const res = await this.fetch('/dsp/content/v2/queryContentByOrder?orderGuid='+id, '', 'get')
            if (res && res.code === this.successCode) {
                this.advContentDto = res.data[0] || null
                return res.data[0] || {}
            }
            return {}
        },
        async upVideo () {
            this.orderDataCopy = this.orderDataStr ? JSON.parse(this.orderDataStr) : await this.getDetail()
            this.orderDataCopy.advContentDto = this.advContentDto || await this.getOldResource(this.$route.query.orderId)
            this.$set(this.orderDataCopy, 'showUpload', true)
            tzx_czcPush('order_payok', 'clickUpload')
        }
    }
}
</script>


